import React from "react";
import { dispatch } from '@rematch/core';
import { Tab, Label, Menu, Message, Segment, Header, Icon, Checkbox, Image, Popup } from "semantic-ui-react";
import convertIcon from "../../../../../../helpers/convert-Icon";
import EllipsisTooltip from "../../../../../common/EllipsisTooltip";
import ErrorMessage from '../summaryTabs/ErrorMessage'
import NoSummaryData from '../summaryTabs/NoSummaryDataPage'
import PlaceholderCardImage from './../../../../../drive/PlaceHolder/PlaceHolderLines'

class NoteTabs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0
        }
    }

    componentWillMount() {

    }

    onTabChange = (event, data) => {
        this.setState({ activeIndex: data.activeIndex })
    }

    render() {
        const { loadingActivitySummary } = this.props
        let contentErrorList = <div>
            {this.props.activitySummary && this.props.activitySummary.map((m, i) => {
                return <Segment.Group
                    key={i}
                    size="small"
                    className={`tabContent `}>
                    <Header as='h6' attached='top'>
                        <EllipsisTooltip name={m.name} />
                    </Header>
                    {m.notes.map((cont, i2) => {
                        return <Segment
                            id={cont._id + "_cont"}
                            key={i2}
                            onClick={(e, data) => this.handleContent(e, cont)}
                            className={`${this.state._id === cont._id ? 'active' : ""}`}
                            style={{ height: "46px" }}>
                            <div
                                className="float-left"
                                style={{ width: "calc(100% - 310px)" }}>
                                <Icon
                                    name={convertIcon(cont.type)}
                                    onClick={(e, data) => this.handleContentType(e, cont)}
                                    className="f_14 float-left text-left"
                                    style={{ width: "20px" }}
                                /> &nbsp;
                                <p
                                    className="float-left"
                                    style={{ width: "calc(100% - 30px)" }}
                                >
                                    <EllipsisTooltip name={cont.content} />
                                </p>

                            </div>
                            <div className="float-right text-right" style={{ width: "280px" }}>
                                {cont.scope === "Private" ?
                                    <span className="clr-red">
                                        <Icon name="warning sign" />
                                        Workspace library
                                     </span>
                                    :
                                    <span className="clr-blue">
                                        Public library
                                    </span>
                                }
                                &nbsp;&nbsp;&nbsp;
                                {cont.authorObj ?
                                    <Popup
                                        className="popupStyled"
                                        inverted
                                        trigger={
                                            <Image src={cont.authorObj.profilePic} avatar />
                                        }
                                        content={
                                            <span>
                                                {cont.authorObj.firstName}&nbsp;
                                        {cont.authorObj.lastName}
                                            </span>
                                        }
                                    /> : null}
                                <Checkbox
                                    label='Required' />&nbsp;&nbsp;&nbsp;&nbsp;
                                 <Popup
                                    className="popupStyled"
                                    inverted
                                    trigger={
                                        <Icon
                                            className="clr-orange"
                                            name="trash alternate"
                                            onClick={(e, data) => this.handleContentDelete(e, cont)} />
                                    }
                                    content="Delete"
                                />
                            </div>
                        </Segment>
                    })}
                </Segment.Group>
            })}
        </div>

        const panes = [
            {
                menuItem:
                    <Menu.Item key='All'>
                        All <Label>{this.props.totalNote}</Label>
                    </Menu.Item>,
                render: () => <Tab.Pane className="border-none bg-light-blue" >
                    {loadingActivitySummary ?
                        <PlaceholderCardImage /> :
                        <React.Fragment>

                            {contentErrorList}
                        </React.Fragment>
                    }
                </Tab.Pane>
            },
            {
                menuItem:
                    <Menu.Item key='Workspace'>
                        Workspace Library <Label>345</Label>
                    </Menu.Item>,
                render: () => <Tab.Pane className="bg-light-blue">Workspace</Tab.Pane>
            },
            {
                menuItem:
                    <Menu.Item key='Public'>
                        Public Library<Label>234</Label>
                    </Menu.Item>,
                render: () => <Tab.Pane className="bg-light-blue">Public</Tab.Pane>
            }
        ]

        return (
            <div >
                <Tab
                    style={{ padding: 0 }}
                    panes={panes}
                    onTabChange={this.onTabChange}
                />
            </div>
        );
    }
}
export default NoteTabs;
